import mode from '../mode';
import * as apiConstants from '../../constants/apiConstants';
import {createApiPath, createFetchAndCall, cleanWhitespace} from '../fetch/fetchServices';

class CreateAccount {

  static submitUser(user) {
    if (mode.staticAPI) {
      return this.fakeSubmitUser(user);
    } else {
      return this.realSubmitUser(user);
    }
  }

  static fakeSubmitUser() {
    return new Promise((resolve) => {
      //we would probably do something here that wouldn't be logging
      //credentials to console
      setTimeout(() => {
        resolve(Object.assign({},
          {
            "status": "201",
            "statusText": "Successfully registered user.",
            "responseText": {
              "userId": "24"
            }
          }
        ));
      }, 1000);
    });
  }

  static realSubmitUser(user) {
    user.username = cleanWhitespace(user.username);
    user.email = cleanWhitespace(user.email);
    let createUserApi = createApiPath(apiConstants.createUserApi);
    let options = {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        username: user.username,
        email: user.email,
        company:{
          name: user.companyName,
        },
        telephone: user.phoneNumber,
        firstName: user.firstName,
        lastName: user.lastName,
        jobTitle: user.jobTitle,
        googleCaptcha: user.googleCaptcha
      })
    };
    return createFetchAndCall(createUserApi, options);
  }

}
export default CreateAccount;



/** WEBPACK FOOTER **
 ** ./src/api/account/userCreationApi.js
 **/